"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_IS_PUBLIC = exports.SET_COUNTRY_CODE = void 0;
exports.default = meta;
exports.initialState = void 0;
exports.setCountryCode = setCountryCode;
exports.setIsPublic = setIsPublic;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SET_COUNTRY_CODE = exports.SET_COUNTRY_CODE = 'SET_COUNTRY_CODE';
var SET_IS_PUBLIC = exports.SET_IS_PUBLIC = 'SET_IS_PUBLIC';
function setCountryCode(code) {
  if (typeof code !== 'string') {
    throw new Error("code is required and must be a string -- received: ".concat(code));
  }
  return {
    type: SET_COUNTRY_CODE,
    code: code
  };
}
function setIsPublic(value) {
  if (typeof value !== 'boolean') {
    throw new Error("value is required and must be a boolean -- received: ".concat(value));
  }
  return {
    type: SET_IS_PUBLIC,
    value: value
  };
}
var initialState = exports.initialState = {
  country: 'US'
};
function meta() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_COUNTRY_CODE:
      return _objectSpread(_objectSpread({}, state), {}, {
        country: action.code
      });
    case SET_IS_PUBLIC:
      return _objectSpread(_objectSpread({}, state), {}, {
        isPublic: action.value
      });
    default:
      return state;
  }
}